import React from 'react';
import { MailIcon } from 'lucide-react';
import { BRAND, CONTACT_EMAIL, PRODUCT_NAME } from '../data/salesContent';
export function SiteFooter() {
  return <footer className="bg-ink px-5 py-12 text-cream" data-id="element-199" data-mp="3racdildve2yv">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 text-center md:flex-row md:justify-between md:text-left" data-id="element-200" data-mp="3mgrfwug6vb07">
        <div data-id="element-201" data-mp="3hi6bsjxtg76h">
          <p className="text-lg font-bold tracking-[0.2em]" data-id="element-202" data-mp="3hgdbrnhpkl7g">{BRAND}</p>
          <p className="mt-1 font-serif text-sm uppercase tracking-wider text-cream/80" data-id="element-203" data-mp="3difpasfbod7r">{PRODUCT_NAME}</p>
          <p className="mt-2 text-sm text-cream/70" data-id="element-204" data-mp="38g6vjtuml74l">© 2026 {BRAND} · Todos los derechos reservados.</p>
        </div>
        <div className="md:text-right" data-id="element-205" data-mp="33kriv58cth9r">
          <p className="text-sm text-cream/70" data-id="element-206" data-mp="2yk3pwe0keqcw">¿Tenés alguna consulta sobre el producto?</p>
          <a href={`mailto:${CONTACT_EMAIL}`} className="mt-1 inline-flex items-center gap-2 rounded text-base font-semibold text-rose-soft transition-colors duration-150 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-soft/60" data-id="element-207" data-mp="11r228kr81v93">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-208" data-mp="15sy8ccs71sxn" />
            {CONTACT_EMAIL}
          </a>
        </div>
      </div>
    </footer>;
}